"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m11.9999 7.0625 3-3-3-3V3c-4.3722.0001-8.016 3.1179-8.83 7.2514l1.9379.5192C5.6888 7.4909 8.5534 5.0001 11.9999 5v2.0625zM12.0002 19c-2.5714 0-4.8189-1.3864-6.0358-3.4525l1.7054-.9846-4.0976-1.098-1.0986 4.098 1.7584-1.0152C5.7948 19.2115 8.6886 21 12.0002 21a8.9897 8.9897 0 0 0 2.8631-.465l-.5191-1.9371a6.9874 6.9874 0 0 1-2.344.4021zm6.0257-3.4354c.6189-1.0441.9743-2.2629.9743-3.5646 0-2.11-.9336-4.0019-2.4101-5.2853l1.4169-1.4169c1.8373 1.6478 2.9932 4.04 2.9932 6.7022 0 1.6661-.4528 3.2265-1.2419 4.5648l1.8204 1.051-4.0981 1.0981-1.098-4.0981 1.6433.9488z"
  })];
};

exports.default = _default;